export const management = {
  routes: [
    {
      path: "/management/template-edit",
      component: () => import("../management-template-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/template-edit",
      component: () => import("../workspace-template-view"),
    },
  ],
};
